import Cookies from "js-cookie";
import CryptoJS from "crypto-js";

const SECRET_KEY = "*#PlayPro*_95#*";
const DEFAULT_EXPIRY_DAYS = 7; // Common variable for expiry days

const setUser = async (user, expiryDays = DEFAULT_EXPIRY_DAYS) => {
  const now = new Date();
  const expiryTime = now.getTime() + expiryDays * 24 * 60 * 60 * 1000; // Convert days to milliseconds

  const dataWithExpiry = {
    user: user,
    expiry: expiryTime,
  };

  const encryptedUser = CryptoJS.AES.encrypt(
    JSON.stringify(dataWithExpiry),
    SECRET_KEY
  ).toString();

  clearUser();
  try {
    localStorage.setItem("playprologin", encryptedUser);
  } catch (e) {
    debugger;
  }
};

const getUser = () => {
  const encryptedUser = localStorage.getItem("playprologin");
  if (!encryptedUser) return null;

  try {
    const bytes = CryptoJS.AES.decrypt(encryptedUser, SECRET_KEY);
    const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));

    // Check if data has expired
    const now = new Date().getTime();
    if (now > decryptedData.expiry) {
      // Data has expired, clear it and return null
      clearUser();
      return null;
    }

    return decryptedData.user;
  } catch (error) {
    console.error("Error decrypting user data", error);
    return null;
  }
};

const clearUser = async () => {
  localStorage.removeItem("playprologin");
};

const setCachedQueryParams = async (
  params,
  expiryDays = DEFAULT_EXPIRY_DAYS
) => {
  const encryptedUser = CryptoJS.AES.encrypt(
    JSON.stringify(params),
    SECRET_KEY
  ).toString();
  Cookies.set("queryParams", encryptedUser, { expires: expiryDays });
};

const getCachedQueryParams = () => {
  const cachedParams = Cookies.get("queryParams");
  if (!cachedParams) return null;

  try {
    const bytes = CryptoJS.AES.decrypt(cachedParams, SECRET_KEY);
    const decryptedParams = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    return decryptedParams;
  } catch (error) {
    console.error("Error decrypting user data", error);
    return null;
  }
};

const clearCachedQueryParams = async () => {
  Cookies.remove("queryParams");
};

const setToken = async (token, expiryDays = DEFAULT_EXPIRY_DAYS) => {
  Cookies.set("token", token, { expires: expiryDays });
};

const getToken = async () => {
  return Cookies.get("token");
};

const clearToken = async () => {
  Cookies.remove("token");
};

const updateUser = (updates) => {
  const encryptedUser = localStorage.getItem("playprologin");
  if (!encryptedUser) return;

  try {
    const bytes = CryptoJS.AES.decrypt(encryptedUser, SECRET_KEY);
    const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));

    const newUserDetails = {
      ...decryptedData.user,
      ...updates,
    };

    const newStorageData = {
      user: newUserDetails,
      expiry: decryptedData.expiry,
    };

    const encryptedData = CryptoJS.AES.encrypt(
      JSON.stringify(newStorageData),
      SECRET_KEY
    ).toString();
    clearUser();
    localStorage.setItem("playprologin", encryptedData);
  } catch (error) {
    console.error("Error updating user", error);
  }
};

export {
  setUser,
  getUser,
  clearUser,
  setToken,
  getToken,
  clearToken,
  setCachedQueryParams,
  getCachedQueryParams,
  clearCachedQueryParams,
  updateUser,
};
